import React from "react";
import { Outlet } from "react-router-dom";

import "./Dashboard.css";
import SideBar from "../SideBar/SideBar";
import { useState } from "react";
import expandIcon from "../../assets/images/icons/expand.svg";
import collapseIcon from "../../assets/images/icons/collapse.svg";

const Dashboard = () => {
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(true);

  const toggleSidebar = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
  };
  return (
    <div className={`layout ${!isSidebarCollapsed ? "collapsed" : ""}`}>
      <div className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <SideBar toggleSidebar={toggleSidebar} />
      </div>
      <div className="main">
        <div className="content-container">
          <Outlet />
        </div>
      </div>

      <button
        className={`btn-menu ${
          isSidebarCollapsed ? "btn-menu-collapsed" : "btn-menu-not-collapsed"
        }`}
        onClick={toggleSidebar}
        aria-label={
          isSidebarCollapsed
            ? "Collapse sidebar navigation menu"
            : "Expand sidebar navigation menu"
        }
      >
        <img
          src={isSidebarCollapsed ? expandIcon : collapseIcon}
          width={18}
          alt="SideBar toggle icon"
        />
      </button>
    </div>
  );
};

export default Dashboard;
